<template>
  <transition name="fade">
    <div class="onboarding" v-if="role === 'surgeon'">
      <div class="step-button-link">
        <router-link :to="{name: info[step-1].routeName}">
          <rp-button
            type="primary">
            {{info[step-1].name}}
          </rp-button>            
        </router-link>
        <div class="step-info-text">
          <h4>Welcome to RayPRO</h4>
          <h5 v-if="this.step === 1">To get started, <router-link class="onboarding-link" :to="{ name: 'hospital-onboarding'}">search for your hospital</router-link> and associate it with your account. If your hospital is not yet in our system you can <router-link class="onboarding-link" :to="{ name: 'add-hospital'}">add it</router-link>.</h5>
          <h5 v-if="this.step === 2">We now recommend that you <router-link class="onboarding-link" :to="{ name: 'add-patient'}">add your patients</router-link> to your account.</h5>
          <h5 v-if="this.step === 3">You can now <router-link class="onboarding-link" :to="{ name: 'add-operation'}">schedule surgeries</router-link> for the patients you have added.</h5>
          <h5 v-if="this.step === 4">View your patient feedback on your <router-link class="onboarding-link" :to="{ name: 'Overview'}">dashboard</router-link> NOTE: Results will only show once at least 10 patients have provided feedback.</h5>
        </div>
      </div>

      <div class="step-info">
        <h4>Onboarding step {{step}} of 4</h4>
        <div class="step-buttons">
          <rp-button @click="previousStep" type="secondary" v-if="this.step !== 1">Back</rp-button>
          <rp-button @click="nextStep" type="secondary" v-if="this.step !== 4">Next</rp-button>
          <rp-button @click="done" type="secondary" v-if="this.step === 4">Done</rp-button>
        </div>
      </div>
    </div>
    <div class="onboarding" v-if="role === 'nurse'">
      <div class="step-button-link">
        <router-link :to="{ name: 'GenerateAccessCode'}" v-if="this.step === 1">
          <rp-button
            type="primary">
            Get access code
          </rp-button>
        </router-link>
        <router-link :to="{ name: 'add-patient'}" v-if="this.step === 2">
          <rp-button
            type="primary">
            Add patients
          </rp-button>
        </router-link>
        <router-link :to="{ name: 'add-operation'}" v-if="this.step === 3">
          <rp-button
            type="primary">
            Schedule surgery
          </rp-button>
        </router-link>
        <div class="step-info-text">
          <h4>Welcome to RayPRO</h4>
          <h5 v-if="this.step === 1">Before you can add patients or surgeries you must <router-link class="onboarding-link" :to="{ name: 'GenerateAccessCode'}">generate an access code</router-link> and give it to your surgeon.</h5>
          <h5 v-if="this.step === 2">Add your patients <router-link class="onboarding-link" :to="{ name: 'add-patient'}">here</router-link>.</h5>
          <h5 v-if="this.step === 3">Now that you've added patients, you can <router-link class="onboarding-link" :to="{ name: 'add-operation'}">schedule surgeries</router-link> for the patients you have added.</h5>
        </div>
      </div>

      <div class="step-info">
        <h4>Onboarding step {{step}} of 3</h4>
        <div class="step-buttons">
          <rp-button @click="previousStep" type="secondary" v-if="this.step !== 1">Back</rp-button>
          <rp-button @click="nextStep" type="secondary" v-if="this.step !== 3">Next</rp-button>
          <rp-button @click="done" type="secondary" v-if="this.step === 3">Done</rp-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import Button from 'raypro_ui/src/components/ui/inputs/Button'

  import store from '@/store/'
  import * as onboarding from 'raypro_ui/src/store/modules/onboarding/types'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Onboarding',

    components: {'rp-button': Button},

    data() {
      return {
        step: 1,
        info: [
          {
            routeName: 'hospital-onboarding',
            name: 'Find hospital'
          },
          {
            routeName: 'add-patient',
            name: 'Add a patient'
          },
          {
            routeName: 'add-operation',
            name: 'Add a surgery'
          },
          {
            routeName: 'Overview',
            name: 'View dashboard'
          }
        ]
      }
    },

    mounted() {
      this.step = 1
    },

    computed: {
      ...mapGetters(['isOnboarded', 'authUser']),

      role() {
        return this.authUser ? this.authUser.roles[0].name : null
      }
    },

    methods: {
      previousStep() {
        if(this.step < 1) {
          return
        }
        this.step--
      },
      nextStep() {
        this.step++
      },

      done() {
        const onboarded = [...this.isOnboarded]

        onboarded.push(this.authUser.id)

        store.commit(onboarding.IS_ONBOARDED, onboarded)
        this.$emit('doneOnboarding')
      }
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/main.sass'
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import '../stylesheets/helpers/mixins'

  .fade-enter-active, .fade-leave-active
    transition: opacity .3s ease-in-out

  .fade-enter, .fade-leave-to
    opacity: 0

  .slide-enter-active, .slide-leave-active
    transition: all .3s ease-in-out

  .slide-enter, .slide-leave-to
    opacity: 0
    transform: translateY(-10px)

  .onboarding
    z-index: 4
    background: white
    color: $color-text
    position: -webkit-sticky
    position: sticky
    bottom: 0
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5)
    display: flex
    justify-content: space-between
    flex-wrap: wrap
    padding: 20px 30px
    
    @include media($media-medium)
      z-index: 6

    .step-button-link
      display: flex
      align-items: center
      margin-top: -20px

      button
        font-size: 12px
      
      .step-info-text
        margin-top: 20px
        margin-left: 20px

        h4
          font-size: 16px
          padding: 0px
          margin: 0px

        h5
          font-size: 13px
          padding: 0px
          padding-top: 5px
          margin: 0px
          font-weight: normal

    
    .step-info
      display: flex
      align-items: center
      justify-content: center

      h4
        font-size: 12px

      .step-buttons
        margin-top: -20px
        // margin-left: 20px
        display: flex

        .btn
          margin-left: 10px
          font-size: 12px

  .onboarding-link
    color: $color-primary
    text-decoration: underline
    &:visited
      color: $color-primary
</style>



// WEBPACK FOOTER //
// src/components/Onboarding.vue